import { updateObject } from "../../util/updateObject";
import * as actionTypes from "./actionTypes";
import {
  configurazioneFilterDataInitialState,
  currentConfigurazioneFormDataInitialState,
  currentConfigurazioneInitialState,
  duplicateConfigurazioneInitialState,
  treeObjectInitialState,
} from "./helper";

const initialState = {
  configurazioneData: {
    data: [],
    lastUpdated: "",
    loading: false,
  },
  currentConfigurazione: currentConfigurazioneInitialState,
  configurazioneFilterData: configurazioneFilterDataInitialState,
  currentPrincipaleTree: treeObjectInitialState,
  currentSecondarioTree: treeObjectInitialState,
  configurazioneFormData: currentConfigurazioneFormDataInitialState,
  duplicateConfigurazione: duplicateConfigurazioneInitialState,
  updateAssociazioneLoading: false,
  refreshLoading: false,
};

const setConfigurazioneData = (state, action) => {
  return updateObject(state, {
    configurazioneData: updateObject(state.configurazioneData, {
      [action.key]: action.value,
    }),
  });
};

const setConfigurazioneDetails = (state, action) => {
  return updateObject(state, {
    currentConfigurazione: updateObject(state.currentConfigurazione, {
      [action.key]: action.value,
    }),
  });
};

const setConfigurazioneFilterData = (state, action) => {
  return updateObject(state, {
    configurazioneFilterData: updateObject(state.configurazioneFilterData, {
      [action.key]: action.value,
    }),
  });
};

const setPrincipaleTreeObject = (state, action) => {
  return updateObject(state, {
    currentPrincipaleTree: updateObject(state.currentPrincipaleTree, {
      [action.key]: action.value,
    }),
  });
};

const setSecondarioTreeObject = (state, action) => {
  return updateObject(state, {
    currentSecondarioTree: updateObject(state.currentSecondarioTree, {
      [action.key]: action.value,
    }),
  });
};

const setUpdateFormData = (state, action) => {
  return updateObject(state, {
    configurazioneFormData: updateObject(state.configurazioneFormData, {
      [action.key]: action.value,
    }),
  });
};

const setUpdateConfigurazione = (state, action) => {
  return updateObject(state, {
    updateAssociazioneLoading: action.value,
  });
};

const setUpdateRefreshLoading = (state, action) => {
  return updateObject(state, {
    refreshLoading: action.value,
  });
};

const duplicateConfigurazione = (state, action) => {
  return updateObject(state, {
    duplicateConfigurazione: updateObject(state.duplicateConfigurazione, {
      [action.key]: action.value,
    }),
  });
};

const updateLastUpdated = (state, action) => {
  return updateObject(state, {
    configurazioneData: updateObject(state.configurazioneData, {
      lastUpdated: action.value,
    }),
  });
}

const configurazioneReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CONFIGURAZIONE_DATA_AND_LOADING:
      return setConfigurazioneData(state, action);
    case actionTypes.GET_CONFIGURAZIONE_DETAILS_DATA_AND_LOADING:
      return setConfigurazioneDetails(state, action);
    case actionTypes.GET_CONFIGURAZIONE_FILTER_DATA_AND_LOADING:
      return setConfigurazioneFilterData(state, action);
    case actionTypes.GET_PRINCIPALE_TREE_OBJECT:
      return setPrincipaleTreeObject(state, action);
    case actionTypes.GET_SECONDARIO_TREE_OBJECT:
      return setSecondarioTreeObject(state, action);
    case actionTypes.GET_UPDATE_FORM_DATA:
      return setUpdateFormData(state, action);
    case actionTypes.UPDATE_CONFIGURAZIONE_LOADING:
      return setUpdateConfigurazione(state, action);
    case actionTypes.DUPLICATE_CONFIGURAZIONE:
      return duplicateConfigurazione(state, action);
    case actionTypes.GET_CONFIGURAZIONE_REFRESH_LOADING:
      return setUpdateRefreshLoading(state, action);
    case actionTypes.UPDATE_LAST_UPDATED_VALUE:
      return updateLastUpdated(state, action);
    default:
      return state;
  }
};
export default configurazioneReducer;
